import { render, staticRenderFns } from "./DatatableEntitiesList.vue?vue&type=template&id=4ccc3e5c"
import script from "./DatatableEntitiesList.vue?vue&type=script&lang=js"
export * from "./DatatableEntitiesList.vue?vue&type=script&lang=js"
import style0 from "./DatatableEntitiesList.vue?vue&type=style&index=0&id=4ccc3e5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports